import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProductDetailAttributeValue" }
const _hoisted_2 = { class: "ProductDetailAttributeValue-title" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ProductDetailAttributeValue-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "10"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attribute_modal = _resolveComponent("attribute-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.attrData.label), 1),
      _createElementVNode("div", {
        class: "ProductDetailAttributeValue-select",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modal.openModal && _ctx.modal.openModal(...args)))
      }, [
        _createElementVNode("img", {
          class: "ProductDetailAttributeValue-img",
          src: _ctx.selectedValue.image,
          alt: _ctx.selectedValue.label
        }, null, 8, _hoisted_3),
        _createElementVNode("div", {
          class: "ProductDetailAttributeValue-color u-hidden",
          style: _normalizeStyle([{"width":"60px","height":"40px"}, { background: _ctx.selectedValue.color }])
        }, null, 4),
        _createElementVNode("label", null, _toDisplayString(_ctx.selectedValue.label), 1),
        _hoisted_4
      ])
    ]),
    _createVNode(_component_attribute_modal, {
      ref: "modal",
      values: _ctx.attrData.values,
      attr: _ctx.attrId
    }, null, 8, ["values", "attr"])
  ], 64))
}